import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceIssuedCategoryDto extends EpimsBaseEntityDto {
  IssuedCategoryName: string;

}
